// Fixed option lists for <ShipmentForm> — values are what the server stores.
import { createYesNoOptions } from '@/config/formOptions';

// Server enum `inbound_type`. The Add screen has no control for it — it always sends.
export const INBOUND_TYPE = Object.freeze({
  toReceive: 'TO_RECEIVED',
  received: 'RECEIVED',
});

// `multiSiteTransfer` is validated as a boolean string, so the values are 'true'/'false'.
export const MULTI_SITE_TRANSFER = Object.freeze({ no: 'false', yes: 'true' });

export const buildMultiSiteTransferOptions = createYesNoOptions(MULTI_SITE_TRANSFER);

// Same `feedstock_category` / `preferred_allocation` enums the contracts slice uses.
